import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";

export const book_section_mark_small: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        fillRule="evenodd"
        stroke="currentcolor"
        strokeWidth="1"
        d="M4.5,18.4997 L4.5,5.4997 C4.5,4.3957 5.396,3.4997 6.5,3.4997 L19.5,3.4997 L19.5,16.5017 L6.5,16.5017 C5.396,16.5017 4.5,17.3957 4.5,18.4997 C4.5,19.6037 5.396,20.5017 6.5,20.5017 L20,20.4997 M7,18.4997 L20,18.4997 M13.5,10.0002 C13.5,10.8282 12.829,11.5002 12,11.5002 C11.171,11.5002 10.5,10.8282 10.5,10.0002 C10.5,9.1712 11.171,8.5002 12,8.5002 C12.829,8.5002 13.5,9.1712 13.5,10.0002 Z M12,8.5002 C11.171,8.5002 10.5,7.8282 10.5,7.0002 C10.5,6.1712 11.171,5.5002 12,5.5002 C12.829,5.5002 13.5,6.1712 13.5,7.0002 M12,11.5002 C12.829,11.5002 13.5,12.1712 13.5,13.0002 C13.5,13.8292 12.829,14.5002 12,14.5002 C11.171,14.5002 10.5,13.8292 10.5,13.0002"
      />
    </svg>
  );
};
